import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps, StaffSession } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);
  const newData: StaffSession[] = [];

  if (Object.keys(res.data).length) {
    for (const i in res.data.data) {
      const {
        total_time_spent = 0,
        total_sessions = 0,
        last_login = new Date(1900, 1, 1), // Explicitly weird date to make sure it's not undefined
        full_name = "",
        roles = [],
        avg_session_duration = 0,
      } = res.data.data[i];
      newData.push({
        name: full_name,
        lastLogin: new Date(last_login),
        totalSessions: total_sessions,
        avgSessionDuration: Math.round(avg_session_duration / 60), // Convert seconds into minutes
        roles,
        totalTimeSpent: Math.round(total_time_spent / 60), // Convert seconds into minutes
      });
    }

    return newData;
  }

  return null;
};

export const useGetStaffSessions = ({
  dateRange,
  startDate,
  endDate,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.staffSessionsWithFilters({
      dateRange,
      startDate,
      endDate,
    }),
    queryFn: () => {
      return api.get("analytics/staff/sessions", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Staff Sessions]", res);
      handleErrors(res, "query");
    },
  });
};
